<template>
  <header class="header">
    <div class="header__animation" />
    <div class="header__container">
      <ElSkeleton
        class="header__container__skeleton skeleton"
        animated
      >
        <template #template>
          <ElSkeletonItem
            variant="p"
            class="skeleton__back"
          />
          <ElSkeletonItem
            variant="p"
            style="width: 527px; height: 120px; border-radius: 8px"
            class="skeleton__text"
          />
        </template>
      </ElSkeleton>
    </div>
    <ElSkeleton
      class="header__mobile-block"
      animated
    >
      <template #template>
        <ElSkeletonItem
          class="header__mobile-block__item"
          variant="p"
        />
      </template>
    </ElSkeleton>
  </header>

  <main class="container container-skeleton">
    <DetailSkeleton
      v-for="{ id, size } in skeletonCads"
      :key="id"
      :size="size"
    />
  </main>
</template>

<script setup lang="ts">
import { ElSkeleton, ElSkeletonItem } from 'element-plus';
import { skeletonCads } from '../constants';
import DetailSkeleton from './DetailSkeleton.vue';
</script>

<style scoped lang="scss">
@import "@/assets/style/include";

@keyframes background-animation {
  0% {
    background-position: 0 100%; /* Левый нижний угол */
  }
  50% {
    background-position: 100% 0; /* Правый верхний угол */
  }
  100% {
    background-position: 0 100%; /* Возвращаемся в левый нижний угол */
  }
}

.header {
  width: 100%;
  min-height: 700px;
  margin-bottom: $containerPaddingFlexTablet;
  background-color: #D7D7D7;
  position: relative;

  &__animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.125) 50%, rgba(0, 0, 0, 0) 100%);
    background-size: 200% 200%; /* Увеличиваем размер фона для анимации */
    animation: background-animation 3s linear infinite;
  }

  &__mobile-block {
    display: none;
    margin-top: -5px;
    &__item{
      width: 100%;
      height: 120px;
      border-radius: 8px;
      margin-bottom: -5px;
    }
  }
  &__container {
    width: 100%;
    max-width: 1800px;
    margin: 0 auto;
    &__skeleton {
      align-items: flex-end;
      padding: 53px 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 16px;
    }
  }
}
.skeleton {
  &__back{
      width: 170px;
      height: 42px;
      border-radius: 52px
  }
}


.container-skeleton {
  display: flex;
  flex-direction: column;
  gap: $containerPaddingFlexMobile;
  padding-bottom: $containerPaddingFlexMobile;
}

@include media-breakpoint-down("lg") {
  .header {
    min-height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__mobile-block {
      display: block;
    }

    &__container__skeleton {
      align-items: flex-start;
      padding: 20px 30px;
    }
  }
  .skeleton__text{
      display: none;
    }
  }

@include media-breakpoint-down("sm") {
  .header__container__skeleton {
    padding-left: 12px;
  }
  .skeleton__back {
    width: 46px;
    height: 28px;
  }
}

@include media-breakpoint-down("md") {
  .header {
    min-height: 380px;
  }
}
</style>
